import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { Model } from '../../backendmodel';
import { DataQualityLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DataQualityLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {},
            parameters: '*'
        }
    }
})
export class DataQualityLinkedServiceAdapter extends LinkedServiceAdapter<DataQualityLinkedService> {

    protected modelConstructor(): new () => DataQualityLinkedService {
        return DataQualityLinkedService;
    }

    protected model(): IModel {
        return DataQualityLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(_linkedService: DataQualityLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(_linkedServiceResource: Model.LinkedServiceResource, linkedService: DataQualityLinkedService): Promise<DataQualityLinkedService> {
        return linkedService;
    }
}
